
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const Histogram = ({data}) => {
    



    // Calcular los bins del histograma
    const binSize = 10; // Define el tamaño del bin
    const min = Math.min(...data);
    const max = Math.max(...data);
    const numBins = Math.ceil((max - min) / binSize);

    const bins = new Array(numBins).fill(0);
    data.forEach(value => {
        const binIndex = Math.floor((value - min) / binSize);
        bins[binIndex]++;
    });

    const labels = Array.from({ length: numBins }, (_, i) => `${min + i * binSize} - ${min + (i + 1) * binSize}`);
    
    const chartData = {
        labels: labels,
        datasets: [
            {
                label: 'Frecuencia',
                data: bins,
                backgroundColor: 'rgba(75, 192, 192, 0.6)',
                borderColor: 'rgba(75, 192, 192, 1)',
                borderWidth: 1,
            },
        ],
    };

    const options = {
        scales: {
            x: {
                title: {
                    display: true,
                    text: 'Rangos'
                }
            },
            y: {
                title: {
                    display: true,
                    text: 'Frecuencia'
                }
            }
        }
    };

    return (
        <div>
            <h2>Histograma basado en datos del endpoint</h2>
            <Bar data={chartData} options={options} />
        </div>
    );
};

export default Histogram;
